import { AuthorizeResult } from 'react-native-app-auth'
import { Cache } from '@src/models/app.types'
import {
  HealthDataMeasurementSourceDef,
  HealthDataMeasurementType,
  NumericalSelect,
  Reminder,
  TerraProviderKind,
} from '@src/types'
import { IconDescriptor } from '@components'

export enum UnitSystem {
  Metric = 'metric',
  Imperial = 'imperial',
}

export enum DarkMode {
  Auto = 'auto',
  On = 'on',
  Off = 'off',
}

export interface StatsSetting {
  visible: boolean
  order: number
  key: string
  section: string
  __typename: 'StatsSettings'
}

export enum GlucoseSource {
  Combined = 'combined',
}

export type UserSettingsTypeName = 'UserSettings'

export interface MacroGoalsDaily {
  calories: number
  protein: number
  carbs: number
  netCarbs: number
  fat: number
  __typename: 'MacroGoals'
}

export enum DashboardGraph {
  Glucose = 'glucose',
  Combined = 'combined',
}

export enum HeroChartType {
  GlucoseChart = 'glucoseChart',
  DialChart = 'dialChart',
  NutritionSummaryChart = 'nutritionSummaryChart',
  NoChart = 'noChart',
}

export const DEFAULT_PREFERRED_HERO_CHART = HeroChartType.GlucoseChart

export interface IntegrationsSyncSettings {
  lastSyncedHealth: string | null
  lastSyncedKetoMojo: string | null
  ketoMojoUser?: AuthorizeResult
}

export interface SettingsStoreState {
  cache: Cache
  healthKitSync: boolean
  ketoMojoSync: boolean
  reminders: boolean
  showNetCarbs: boolean
  glucoseSource: GlucoseSource
  glucoseLowThreshold: number
  glucoseHighThreshold: number
  ketoneLowThreshold: number
  ketoneHighThreshold: number
  dashboardGraph: DashboardGraph
  preferredHeroChart: HeroChartType
  unitSystem: UnitSystem
  fastingStart: number
  fastingEnd: number
  macroGoalsDaily: MacroGoalsDaily
  patternsNotifications: boolean
  darkMode: DarkMode
  statsSettings: StatsSetting[]
  backup: any
  integrationsSyncSettings: IntegrationsSyncSettings
  terraProviders: TerraProvider[]
  dailyMeasurementsSourcePriorities: SourcePriorities
  userReminders: Reminder[]
  __typename: UserSettingsTypeName
}

export const TERRA_APPLE_HEALTH = 'Apple Health'

export interface TerraProvider {
  provider: string
  name: string
  active: boolean
  availableTypes: string[] | null
  connectionId: number | null
  status: string | null
  errorReason: string | null
  disabledTypes: string[] | null
  providerKind: TerraProviderKind
}

export type Option = Omit<NumericalSelect, '__typename'>

export enum ThresholdType {
  Glucose = 'glucose',
  Ketone = 'ketone',
}

export interface SourcePriorityListItem extends HealthDataMeasurementSourceDef {
  icon: IconDescriptor
  title: string
}

export type SourcePriorities = {
  [key in HealthDataMeasurementType]: SourcePriorityListItem[] | null
}
